import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Layout } from './components/common';
import Home from './pages/Home';
import BookService from './pages/BookService';
import Donate from './pages/Donate';
import Contact from './pages/Contact';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  const location = useLocation();

  return (
    <Layout>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<BookService />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/contact" element={<Contact />} />
          {/* Placeholder routes */}
          <Route path="/events" element={<ComingSoon title="Events" />} />
          <Route path="/coming-soon" element={<ComingSoon title="Coming Soon" />} />
        </Routes>
      </AnimatePresence>
    </Layout>
  );
};

const Router = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
};

// Simple coming soon component for placeholder routes
const ComingSoon = ({ title }) => {
  useEffect(() => {
    document.title = `${title} - Pragyavan Wellness Centre`;
  }, [title]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-4xl font-display font-bold text-pragyavan-brown mb-4">
          {title}
        </h1>
        <p className="text-warm-gray text-lg mb-8">This page is coming soon. Stay tuned!</p>
        <a
          href="/"
          className="inline-flex items-center px-6 py-3 bg-pragyavan-gold text-pragyavan-brown font-medium rounded-full hover:bg-accent-gold transition-all duration-300 hover:-translate-y-1 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-pragyavan-gold focus:ring-offset-2"
        >
          Return Home
        </a>
      </div>
    </div>
  );
};

export default Router;